export default {
  PANEL_HELP_BUTTON: '23bfa470-75d9-49ba-852a-7d09cb090021',
  SAVED_SECTIONS: 'db865984-80bd-42c1-af05-a5d594b603f8',
};
